import {convertHeightToPx, getDefaultHeight} from '../converters/height'
import {CANVAS_HEIGHT} from '../constants'
import type {CalculateParams} from '../types'
import {getValue, isPage, reportEndlessLoopError, reportCalculationError} from '../utils'

const heightCalculationInProgress = new Set<string>()

export const calculateHeight = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, extensionAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.height(compRef) !== undefined) {
        return
    }

    if (isPage(extensionAPI, compRef)) {
        set.height(compRef, CANVAS_HEIGHT)
        return
    }

    if (heightCalculationInProgress.has(compRef.id)) {
        set.height(compRef, getDefaultHeight(calculateParams))
        reportEndlessLoopError(calculateParams)
        return
    }

    heightCalculationInProgress.add(compRef.id)
    try {
        const {componentLayout} = layoutData
        const {height} = componentLayout ?? {}

        if (!height?.type) {
            set.height(compRef, convertHeightToPx.auto(calculateParams))
            return
        }

        const heightInPx = convertHeightToPx[height.type]({
            ...calculateParams,
            value: getValue(height)
        })
        set.height(compRef, heightInPx)
    } catch (error) {
        set.height(compRef, getDefaultHeight(calculateParams))
        reportCalculationError(calculateParams)
    } finally {
        heightCalculationInProgress.delete(compRef.id)
    }
}
